import React from "react";
import Pagination from "../components/common/pagination";
import ArticleListItem from "../components/article-list-item";
import Layout from "../components/layout";
import PageSectionContainer from "../components/common/page-section-container";
import PageSectionHeading from "../components/common/page-section-heading";
import SEO from "../components/seo";
var AllEditionsList = function AllEditionsList(_ref) {
    var data = _ref.data, pageContext = _ref.pageContext;
    var pageNumber = pageContext.pageNumber, pageCount = pageContext.pageCount;
    var pageTitle = "Alle Ausgaben";
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: pageTitle
    }), /*#__PURE__*/ React.createElement(PageSectionContainer, null, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-4",
        title: pageTitle
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row flex-wrap"
    }, data.allDatoCmsEdition.nodes.map(function (edition, index) {
        var _edition$editorial$im;
        return /*#__PURE__*/ React.createElement(ArticleListItem, {
            key: edition.id,
            authors: edition.editorial.authors,
            excerpt: edition.editorial.excerpt,
            to: "/" + edition.slug + "/" + edition.editorial.slug + "/",
            title: edition.editorial.title,
            image: (_edition$editorial$im = edition.editorial.image) === null || _edition$editorial$im === void 0 ? void 0 : _edition$editorial$im.fluid,
            smallTitle: edition.label,
            index: index,
            authorLinks: false,
            smallTitleClassName: "text-white-important",
            containerStyle: "text-white bg-makroOrange"
        });
    }))), /*#__PURE__*/ React.createElement(Pagination, {
        currentPage: pageNumber,
        pageCount: pageCount,
        basePath: "alle-ausgaben"
    }));
};
var query = "1627486259";
export default AllEditionsList;
